/**
 * 请求参数的封装
 * @param {Object} params
 * @returns params
 */
const params = { param: [], thisPage: 1, pageSize: 0, orderBy: '', desc: false, timestamp: Date.now(), token: '' }
export const getParameter = parameter => {
  if (parameter) {
    return { ...params, ...parameter }
  } else {
    return params
  }
}

export const queryParameter = ({ compareWith = '', propType = 'String', propName = '', value = '', beginValue = '', endValue = '', ignoreCase = true, enabled = true }) => {
  return {
    compareWith,
    propType,
    propName,
    value,
    beginValue,
    endValue,
    ignoreCase,
    enabled
  }
}

export const getParameterField = ({ property = '', value = '', propertyType = 'object', enabled = '' }) => {
  return {
    property,
    value,
    propertyType,
    enabled
  }
}
